// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r1iaVh9z6bAnYJDSb15K {
  display: flex;
  align-items: center;
  padding:11px;
  cursor: pointer;
  height:36px;
}

.y6_n3uAgdf0PrOCIjCn1 {
  background-color:rgba(47,181,199, 0.2);
  border-radius: 4px;
}

.BcclvIuyl3gV_n3e_iVE {
  border:1px solid rgb(47,181,199);
}

.irQxAhDxHpKZpQIAdgPD {
  background-color:rgba(163, 3, 10, 0.4);
  border-radius: 4px;
}
.QVG1TvTgBIgdIZnPsLgf {
  background-color:rgba(163, 3, 10, 0.2);
  border-radius: 4px;
}

.vLFbWbl5qkiUcHitYhvd {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.m9pWwwOaqO1kw6_idGXW {
  background: #32445A !important;
}

.FlxjSHkv_4Er7px3DcJe {
  background: #C7C7C7;
}
`, "",{"version":3,"sources":["webpack://./src/components/tab-switch/tab-switch.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".tabSwitch {\n  display: flex;\n  align-items: center;\n  padding:11px;\n  cursor: pointer;\n  height:36px;\n}\n\n.tabSwitchActive {\n  background-color:rgba(47,181,199, 0.2);\n  border-radius: 4px;\n}\n\n.tabSwitchActiveBorder {\n  border:1px solid rgb(47,181,199);\n}\n\n.tabSwitchActiveHasError {\n  background-color:rgba(163, 3, 10, 0.4);\n  border-radius: 4px;\n}\n.tabSwitchHasError {\n  background-color:rgba(163, 3, 10, 0.2);\n  border-radius: 4px;\n}\n\n.tabLabel {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: flex-start;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.actionSwitchOn {\n  background: #32445A !important;\n}\n\n.actionSwitchOff {\n  background: #C7C7C7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabSwitch": `r1iaVh9z6bAnYJDSb15K`,
	"tabSwitchActive": `y6_n3uAgdf0PrOCIjCn1`,
	"tabSwitchActiveBorder": `BcclvIuyl3gV_n3e_iVE`,
	"tabSwitchActiveHasError": `irQxAhDxHpKZpQIAdgPD`,
	"tabSwitchHasError": `QVG1TvTgBIgdIZnPsLgf`,
	"tabLabel": `vLFbWbl5qkiUcHitYhvd`,
	"actionSwitchOn": `m9pWwwOaqO1kw6_idGXW`,
	"actionSwitchOff": `FlxjSHkv_4Er7px3DcJe`
};
export default ___CSS_LOADER_EXPORT___;
